module.exports = __webpack_public_path__ + "img/dashboard_student.3cd91766.jpg";